// Class: openfl.events._EventDispatcher.Listener

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
function Reflect() {return require("./../../../Reflect");}

// Constructor

var Listener = function(callback,useCapture,priority,useWeakReference) {
	if(useWeakReference && Listener.supportsWeakReference) {
		this.weakRefCallback = new WeakRef(callback);
	} else {
		this.callback = callback;
	}
	this.useCapture = useCapture;
	this.priority = priority;
	this.useWeakReference = useWeakReference;
}

// Meta

Listener.__name__ = "openfl.events._EventDispatcher.Listener";
Listener.__isInterface__ = false;
Listener.prototype = {
	match: function(callback,useCapture) {
		var resolvedCallback = this.callback;
		if(this.weakRefCallback != null) {
			resolvedCallback = this.weakRefCallback.deref();
			if(resolvedCallback == null) {
				return false;
			}
		}
		if((Reflect().default).compareMethods(resolvedCallback,callback)) {
			return this.useCapture == useCapture;
		} else {
			return false;
		}
	}
};
Listener.prototype.__class__ = Listener.prototype.constructor = $hxClasses["openfl.events._EventDispatcher.Listener"] = Listener;

// Init



// Statics


Listener.__meta__ = { obj : { SuppressWarnings : ["checkstyle:FieldDocComment"]}}
Listener.supportsWeakReference = (Reflect().default).hasField($global,"WeakRef")

// Export

exports.default = Listener;